export default {
  PRODUCT: "Product",
  PRODUCTS: "Products",
};
